import { render, staticRenderFns } from "./Cdklist.vue?vue&type=template&id=396a677a&"
import script from "./Cdklist.vue?vue&type=script&lang=js&"
export * from "./Cdklist.vue?vue&type=script&lang=js&"
import style0 from "./Cdklist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports